export default __webpack_public_path__ + "static/media/gesture.bbe8c758.svg";